var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 8.6c-.2-1.5-.4-2.6-1-3C21.2 5.1 16 5 12 5c-4 0-9.2.1-9.8.6-.6.4-.8 1.5-1 3C1 10.1 1 11 1 12s0 1.9.2 3.4.4 2.6 1 3c.6.5 5.8.6 9.8.6 4 0 9.2-.1 9.8-.6.6-.4.8-1.5 1-3 .2-1.5.2-2.4.2-3.4s0-1.9-.2-3.4zm-12.8 7V8.4l6 3.6-6 3.6z",
    fill: "#fff"
  })));
}
export default SvgYoutube;